import { createSlice } from '@reduxjs/toolkit';

const standardsSlice = createSlice({
    name: 'standards',
    initialState: null,
    reducers: {
        setStandards: (state, action) => action.payload,
    },
});

export const { setStandards } = standardsSlice.actions;
export default standardsSlice.reducer;
